module.exports = __webpack_public_path__ + "img/US_SnareResist_ua.58fb03b5.webp";